import { Component, Input } from '@angular/core';

/**
 * Menu tabs component
 */
@Component({
  selector: 'def-menu-tabs',
  templateUrl: './def-menu-tabs.component.html',
  styleUrls: ['./def-menu-tabs.component.scss'],
})
export class DefMenuTabsComponent {
  @Input() icon: string;
  @Input() title: string;
  @Input() active = false;
  @Input() color?: string;
  @Input() selectedTab?: 'reservations' | 'formations';
  @Input() borderSide?: 'left' | 'right' = 'right';
}
